import api from '../lib/api';

export const FETCH_STATS = 'FETCH_STATS';
export const STATS_LOADING = 'STATS_LOADING';

export default {
  fetchStats(marketIds) {
    return (dispatch) => {
      dispatch({ type: STATS_LOADING, payload: true });

      return api.getStats(marketIds)
        .then((stats) => {
          dispatch({ type: FETCH_STATS, payload: stats });
        })
        .then(() => {
          dispatch({ type: STATS_LOADING, payload: false });
        })
        .catch(() => {
          dispatch({ type: STATS_LOADING, payload: false });
        });
    };
  },
};
